import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { AutorisationBnbaccess } from './autorisation-bnbaccess.model';
import { AutorisationBnbaccessPopupService } from './autorisation-bnbaccess-popup.service';
import { AutorisationBnbaccessService } from './autorisation-bnbaccess.service';
@Component({
    selector: 'jhi-autorisation-bnbaccess-dialog',
    templateUrl: './autorisation-bnbaccess-dialog.component.html'
})
export class AutorisationBnbaccessDialogComponent implements OnInit {

    autorisation: AutorisationBnbaccess;
    authorities: any[];
    isSaving: boolean;
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private autorisationService: AutorisationBnbaccessService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['autorisation']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
    }
    clear () {
        this.activeModal.dismiss('cancel');
    }

    save () {
        this.isSaving = true;
        if (this.autorisation.id !== undefined) {
            this.autorisationService.update(this.autorisation)
                .subscribe((res: AutorisationBnbaccess) => this.onSaveSuccess(res), (res: Response) => this.onSaveError(res.json()));
        } else {
            this.autorisationService.create(this.autorisation)
                .subscribe((res: AutorisationBnbaccess) => this.onSaveSuccess(res), (res: Response) => this.onSaveError(res.json()));
        }
    }

    private onSaveSuccess (result: AutorisationBnbaccess) {
        this.eventManager.broadcast({ name: 'autorisationListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError (error) {
        this.isSaving = false;
        this.onError(error);
    }

    private onError (error) {
        this.alertService.error(error.message, null, null);
    }
}

@Component({
    selector: 'jhi-autorisation-bnbaccess-popup',
    template: ''
})
export class AutorisationBnbaccessPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private autorisationPopupService: AutorisationBnbaccessPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if ( params['id'] ) {
                this.modalRef = this.autorisationPopupService
                    .open(AutorisationBnbaccessDialogComponent, params['id']);
            } else {
                this.modalRef = this.autorisationPopupService
                    .open(AutorisationBnbaccessDialogComponent);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/autorisation/autorisation-bnbaccess-dialog.component.ts